import BaseModel from "./base-model";
import { renderStatus, parseDeliveryStatus, DELIVERY_STATUS_4, DELIVERY_STATUS_8, DELIVERY_STATUS_12 } from "./Delivery";

import { formatDate, getDateByTimeZone } from "@/lib/date";

export default class DeliveryStatusLog extends BaseModel {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  get afterString() {
    return renderStatus(parseDeliveryStatus(this.after));
  }

  get beforeString() {
    return renderStatus(parseDeliveryStatus(this.before));
  }

  get isDelivery() {
    const status = parseDeliveryStatus(this.after);

    return status === DELIVERY_STATUS_4 || status === DELIVERY_STATUS_8 || status === DELIVERY_STATUS_12;
  }

  renderCreatedAt(dateFormat = "MM/dd HH:mm") {
    return (
      this.createdAt &&
      formatDate(getDateByTimeZone(this.createdAt), dateFormat)
    );
  }
}
